import React from 'react';
import { Button } from '@sparkol/videoscribe-react-ui';

import { ReactComponent as PeterMagnifyingGlass } from 'imgs/svg-icons/PeterMagnifyingGlass.svg';

import './CharactersBanner.css';
import '../PromoBanner.css';

interface CharactersBannerProps {
  onExploreClick: () => void;
  compact?: boolean;
}

const CharactersBanner: React.FC<CharactersBannerProps> = ({ onExploreClick, compact = false }) => {
  if (compact) {
    return (
      <button
        className="PromoBanner PromoBanner--characters"
        type="button"
        aria-label="Characters"
        onClick={onExploreClick}
      >
        <span className="PromoBanner__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="7" r="4" />
            <path d="M4 22v-2a8 8 0 0 1 16 0v2" />
          </svg>
        </span>
        <span className="PromoBanner__label">
          Characters <span aria-hidden="true">&rsaquo;</span>
        </span>
        <span className="PromoBanner__description">Explore the cast.</span>
        <PeterMagnifyingGlass className="PromoBanner__illustration" aria-hidden="true" />
      </button>
    );
  }

  return (
    <div className="CharactersBanner">
      <div className="CharactersBanner__content">
        <span className="CharactersBanner__badge">NEW</span>
        <h2 className="CharactersBanner__title">Bring a character into every scene</h2>
        <p className="CharactersBanner__description">One person — every pose, every emotion. Meet the cast.</p>
        <Button variant="outlineDarkHover" size="regular" onClick={onExploreClick}>
          Explore characters &rsaquo;
        </Button>
      </div>
      <div className="CharactersBanner__illustration">
        <PeterMagnifyingGlass />
      </div>
    </div>
  );
};

export default CharactersBanner;
